import styled from 'styled-components'

const MyDiv = styled.div`
.card {
    border: 1px solid rgba(0, 0, 0, 0.15);
    border-radius: 8px;
    background: #fff;
    padding: 12px 6px 6px 6px;
    box-shadow:  0px 4px 4px 0px #00000040;
  }
    .tab-list-container {
    flex-grow: 1;
    overflow-x: auto;
  }
 .btn {
    background:rgba(0, 104, 56, 1);
    color:white;
    &:hover{
    background:rgba(0, 104, 56, 1);
    color:white;
  }
}
.badge{
  padding: 10px 10px; 
  border-radius: 8px;
  font-weight: 500; 
}
  .page_wrapper {
     padding-top: 8px;
  }
   .job {
    text-decoration: underline;
    color: rgba(0, 122, 255, 1);
    display: inline-flex;
    align-items: center;
    padding: 4px 8px; 
    border-radius: 16px;
    white-space: nowrap; 
    cursor: pointer;
  }
 .card_box {
  background: white;
  border-radius: 12px;
  filter: drop-shadow(0px 2px 4px rgba(0, 0, 0, 0.15));
  width: auto;
}
  .donut-chart {
    width: 280px;
    height: 250px;
  }
.card-wrapper{
    background: #EEF3FB;
    border-radius: 8px;
}
.legend-row {
    width: 100%;
  }
  
`
export default MyDiv
